import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { from } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import * as DashboardActionTypes from "../../actions/dashboard/dashboard.actions";
import * as MessagesActionTypes from "../../actions/messages/message.actions";
import { AppState } from "../../reducers";
import { DashboardService } from "src/app/shared/services/dashboard/dashboard.service";
import { SnackBarUtils } from "src/app/shared/utils/snackbarUtils";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";

@Injectable()
export class DashboardEffects {
  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    private translate: TranslateService,
    private dashboardService: DashboardService
  ) {}

  getAveragesConsumptionList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActionTypes.getVehicleAverageComsuptionList),
      switchMap((action) =>
        this.dashboardService
          .getAverageComsuptionList(
            action.options.paging,
            action.options.filteringArgs,
            action.options.sortingArgs,
            action.options.advancedFilteringArgs
          )
          .pipe(
            map((result) =>
              DashboardActionTypes.loadVehicleAverageComsuptiontList({
                response: result,
              })
            ),
            catchError((error) => {
              const actions = [
                DashboardActionTypes.loadVehicleAverageComsuptiontList({
                  response: [],
                }),
                MessagesActionTypes.setSnackbar(
                  SnackBarUtils.setSnackBar(
                    this.translate.instant("DashBoard.LoadAveragesError"),
                    SnackbarType.ERROR
                  )
                ),
              ];
              return from(actions);
            })
          )
      )
    )
  );

  getTransactionsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActionTypes.getTransactionsList),
      switchMap((action) =>
        this.dashboardService
          .getTransactionsList(
            action.options.paging,
            action.options.filteringArgs,
            action.options.sortingArgs,
            action.options.advancedFilteringArgs
          )
          .pipe(
            map((result) =>
              DashboardActionTypes.loadTransactionsList({ response: result })
            ),
            catchError((error) => {
              const actions = [
                DashboardActionTypes.loadTransactionsList({ response: [] }),
                MessagesActionTypes.setSnackbar(
                  SnackBarUtils.setSnackBar(
                    this.translate.instant("DashBoard.LoadTransactionsError"),
                    SnackbarType.ERROR
                  )
                ),
              ];
              return from(actions);
            })
          )
      )
    )
  );
}
